import { BaseResponse } from '../../../../../../../types/api/api.types';
import { SendConsultationAnswerRequestData } from '../../../../../../../types/api/endpoints/consultations/answers.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../../../../../utils/api/endpoints/consultationsEndpoints';

const PREFIX = '[sendConsultationAnswerQuery]';

export const SEND_CONSULTATION_ANSWER_QUERY_KEY = 'SEND_CONSULTATION_ANSWER';

export const sendConsultationAnswerQuery = async (data: SendConsultationAnswerRequestData) => {
  console.log(PREFIX, `Sending consultation answer...`);
  const response = await CONSULTATIONS_ENDPOINTS.sendAnswer(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Sent consultation answer.`);
  return json as BaseResponse;
};
